import React, { useState, useEffect } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import AdjustWhModal from "../../../components/Modal/AdjustWhModal";

// Utils
import {
  getDataWithComp,
  getAlert,
  formatCurrency,
  parseCurrency,
} from "../../../../utils/SamuiUtils";

import { formatDateAndTime } from "../../../../utils/DateUtils";

import {
  ExportInventories,
  ExportInventoriesWarehouse,
} from "../../../../utils/ExportUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import ItemModal from "../../../components/Modal/ItemModal";

function Form({ name }) {
  const [activeTab, setActiveTab] = useState(2);
  const [formItemList, setFormItemList] = useState([]);
  console.debug("formItemList", formItemList);
  const [formItemOnHand, setFormItemOnHand] = useState([]);
  console.debug("formItemOnHand", formItemOnHand);
  const [formItemHistory, setFormItemHistory] = useState([]);
  console.debug("formItemHistory", formItemHistory);
  const [formItemOnHandCaseTab, setFormItemOnHandCaseTab] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("stock");

  // ข้อมูลตั้งต้น
  const [itemId, setItemId] = useState(null);
  const [warehouseId, setWarehouseId] = useState(null);

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);

  // Modal
  const [showWhModal, setShowWhModal] = useState(false);
  const handleWhShow = () => setShowWhModal(true);
  const handleWhClose = async () => {
    setShowWhModal(false);
    await initialize();
    await handleItemSearch(searchItemTerm, filterOption);
    await onRowSelectOnHand(itemId, warehouseId);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialize = async () => {
    try {
      // ค้นหาข้อมูลตั้งต้นจาก API_0002_Set_Item
      const itemList = await getDataWithComp(
        "API_0002_Set_Item",
        `AND Reft_ItemOnhand > 0 AND Item_Status = 'Y'  ORDER BY Item_Code ASC`
      );
      if (itemList && itemList.length > 0) {
        setFormItemList(itemList);
      }

      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_WH
      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      await loadLocalStorageData();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };
  const onChangeWarehouse = async (id) => {
    console.debug("onChangeWarehouse", id);
    try {
  const parsedId = id === "" ? "" : parseInt(id, 10);
  setWarehouseId(parsedId);
  onRowSelectOnHand(itemId, parsedId);
  onRowSelectOnHandCaseTab(parsedId);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const loadLocalStorageData = async () => {
    const itemSearch = localStorage.getItem("stc-item-search");
    const itemOption = localStorage.getItem("stc-item-option");
    const itemId = localStorage.getItem("stc-item-id");
    const itemWH = localStorage.getItem("stc-item-wh");
    const activeTab = localStorage.getItem("stc-active-tab");
    const selectedWarehouse = localStorage.getItem("stc-select-warehouse");
    const year = localStorage.getItem("stc-year");
    const month = localStorage.getItem("stc-month");

    if (itemSearch) setSearchItemTerm(itemSearch);
    if (itemOption) setFilterOption(itemOption);
    if (itemSearch || itemOption)
      await handleItemSearch(itemSearch, itemOption);
    if (itemId && itemWH) {
      const parsedItemId = parseCurrency(itemId, 10);
      const parsedItemWH = parseCurrency(itemWH, 10);
      setItemId(parsedItemId);
      await onRowSelectOnHand(parsedItemId, parsedItemWH);
    }
    if (activeTab) setActiveTab(parseCurrency(activeTab, 10));
    if (selectedWarehouse) setWarehouseId(parseCurrency(selectedWarehouse, 10));
    if (year) setYear(year);
    if (month) setMonth(month);
    if (year || month)
      await handleHistorySearch(year, month, itemId, selectedWarehouse);
  };

  // SET ITEM_ONHAND
  const onRowSelectOnHand = async (itemId, whId, opts = {}) => {
    let effectiveWhId = whId || null;
    try {
      // เรียก initialize อีกครั้ง เพื่อที่จะกระตุกตัวมันเองด้วย ตอนที่กด onRow
      //await initialize();

      // ค้นหาใหม่อีกรอบตาม Filter เดิมก่อนหน้า
      // await handleItemSearch();

      setItemId(itemId);
      setFormItemOnHand([]);


      // ค้นหาที่ View : API_1101_WH_ITEM_ONHAND Where Item_Id = ตามตารางซ้าย AND Comp_Id = ล็อกอิน Order By WHName
      const itemOnHand = await getDataWithComp(
        "API_1101_WH_ITEM_ONHAND",
        `AND Item_Id = ${itemId} ORDER BY WH_Name ASC`
      );

      if (itemOnHand && itemOnHand.length > 0) {
        setFormItemOnHand(itemOnHand);
        const preferItemWareSelection = opts.preferItemWareSelection === true;

        if (preferItemWareSelection) {
          if (itemOnHand.length === 1) {
            effectiveWhId = itemOnHand[0]?.WH_Id || null;
          } else {
            const prefer = itemOnHand.find((it) => (it.WH_Name || "").trim() === "คลังสินค้า");
            effectiveWhId = prefer?.WH_Id ?? (whId ?? warehouseId ?? itemOnHand[0]?.WH_Id ?? null);
          }
        } else {
          if (whId !== undefined) {
            effectiveWhId = whId;
          } else if (warehouseId !== undefined && warehouseId !== null && warehouseId !== "") {
            effectiveWhId = warehouseId;
          } else {
            effectiveWhId = itemOnHand[0]?.WH_Id || null;
          }
        }
        if (effectiveWhId !== warehouseId) {
          setWarehouseId(effectiveWhId);
        }
        if (effectiveWhId !== null && effectiveWhId !== "") {
          localStorage.setItem("stc-select-warehouse", effectiveWhId);
          localStorage.setItem("stc-item-id", itemId);
          localStorage.setItem("stc-item-wh", effectiveWhId);
        }
      } else {
        setFormItemOnHand([]);
        effectiveWhId = null;
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    } finally {
      if (effectiveWhId !== null && effectiveWhId !== "") {
        await onRowSelectHistory(itemId, effectiveWhId);
        await onRowSelectOnHandCaseTab(effectiveWhId);
      }
    }
  };

  // API_1201_WH_ITEM_STC (ประวัติคลังสินค้า)
  const onRowSelectHistory = async (itemId, whId) => {
    try {
      setFormItemHistory([]);

      const itemHistory = await getDataWithComp(
        "API_1201_WH_ITEM_STC",
        `AND Item_Id = ${itemId} AND WH_Id = ${whId} ORDER BY STC_SEQ DESC`
      );

      if (itemHistory && itemHistory.length > 0) {
        setFormItemHistory(itemHistory);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
      setFormItemHistory([]);
    }
  };

  // API_1101_WH_ITEM_ONHAND (สินค้าคงคลัง)
  const onRowSelectOnHandCaseTab = async (whId) => {
    try {
      setFormItemOnHandCaseTab([]);

      const itemOnHandCaseTab = await getDataWithComp(
        "API_1101_WH_ITEM_ONHAND",
        `AND WH_Id = ${whId} ORDER BY Item_Code ASC`
      );

      if (itemOnHandCaseTab && itemOnHandCaseTab.length > 0) {
        setFormItemOnHandCaseTab(itemOnHandCaseTab);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
      setFormItemOnHandCaseTab([]);
    }
  };

  // ตอนเลือกคลัง

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);

  const handleBeginWarehouse = async (itemsSelected) => {
    try {
      // ปิด Modal
      setShowItemModal(false);

      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      if (warehouseId === null) {
        setIsLoading(false);
        return getAlert("FAILED", "กรุณาเลือกคลัง");
      }

      console.log(warehouseId)

      const uniqueItems = Array.from(
        new Set(itemsSelected.map((item) => item.Item_Id))
      ).map((id) => itemsSelected.find((item) => item.Item_Id === id));

      // ใช้ Promise.all แทน for loop
      await Promise.all(
        uniqueItems.map((item) =>
          manageWhItemData(
            item.Item_Id, // Item ไอดีของสิ่งนั้นๆ
            item.Item_Code, // Item โค้ดของสิ่งนั้นๆ
            item.Item_Name, // ชื่อ Item นั้นๆ
            parseCurrency(warehouseId), // WarehouseID ของไอเทม
            "BG", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            parseCurrency(0, 10), // ค่าจำนวนที่กรอกจากหน้าจอ
            null, // ไอดีเอกสาร
            "เริ่มต้นคลัง", // เลขเอกสาร
            "เริ่มต้นคลัง", // เลขเอกสารอ้างอิง
            null // หมายเหตุ
          )
        )
      );

      handleItemClose();
      await initialize();
      await onRowSelectHistory(itemId, warehouseId);
      getAlert("OK", "เริ่มต้นคลังสินค้าสำเร็จ");
    } catch (error) {
      getAlert("FAILED", error);
    } finally {
      setIsLoading(false);
    }
  };

  // ใช้สำหรับค้นหาที่ formItemList (พี่แบงค์แจ้งมาให้ Fetch Realtime)
  const [searchItemTerm, setSearchItemTerm] = useState("");
  const [filterOption, setFilterOption] = useState("0");

  // ทำให้มันทีผลแมร่งเลย ไม่ต้องกดแว่นขยาย
  useEffect(() => {
    handleItemSearch(searchItemTerm, filterOption);
  }, [searchItemTerm, filterOption]);

  const handleItemSearch = async (searchItemTerm, filterOption) => {
    // ทำให้ สินค้าทั้งหมด กระพริบ
    setFormItemList([]);

    let query = `AND Item_Status = 'Y' `;

    if (searchItemTerm) {
      query += `AND (Item_Code LIKE '%${searchItemTerm}%' OR Item_Name LIKE '%${searchItemTerm}%' OR Item_Short_Name LIKE '%${searchItemTerm}%') `;
    }

    switch (filterOption) {
      case "0":
        query += `AND Reft_ItemOnhand > 0 `;
        break;
      case "1":
        query += `AND Reft_ItemOnhand >= 0 `;
        break;
      case "2":
        query += `AND Reft_ItemOnhand = 0 `;
        break;
      case "3":
        query += `AND Reft_ItemOnhand < 0 `;
        break;
      case "4":
        break;
      default:
        break;
    }

    query += `ORDER BY Item_Code ASC`;

    const itemList = await getDataWithComp("API_0002_Set_Item", query);
    if (itemList && itemList.length > 0) {
      setFormItemList(itemList);
    } else {
      setFormItemList([]);
    }
  };

  // ใช้สำหรับค้นหาที่ formItemHistory (พี่แบงค์แจ้งมาให้ Fetch Realtime)
  // const [searchHistoryTerm, setSearchHistoryTerm] = useState('');
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const handleHistorySearch = async (year, month, itemId, warehouseId) => {
    let query = `AND Item_Id = ${itemId} AND WH_Id = ${warehouseId} `;

    // if (searchHistoryTerm) {
    //     query += `AND (Item_Code LIKE '%${searchHistoryTerm}%' OR Item_Name LIKE '%${searchHistoryTerm}%') `;
    // }

    let yearInAD = "";
    if (year) {
      yearInAD = (parseCurrency(year) - 543).toString();
    }

    if (yearInAD) {
      query += `AND YEAR(STC_Date) = ${yearInAD} `;
    }

    if (month) {
      query += `AND MONTH(STC_Date) = ${parseCurrency(month)} `;
    }

    query += `ORDER BY STC_SEQ DESC`;

    const itemHistory = await getDataWithComp("API_1201_WH_ITEM_STC", query);

    if (itemHistory && itemHistory.length > 0) {
      setFormItemHistory(itemHistory);
    } else {
      setFormItemHistory([]);
    }
  };

  const getUnit = (item) => {
    let unit =
      formItemList.find((i) => i.Item_Code === item)?.Item_Unit_OUT || "";
    return unit;
  };

  // ใช้สำหรับค้นหาที่ API_1101_WH_ITEM_ONHAND (สินค้าคงคลัง)
  // const [searchTermOnHandCaseTab, setSearchTermOnHandCaseTab] = useState('');
  // const handleSearchOnHandCaseTab = async () => {
  //     let query = `AND WH_Id = ${warehouseId} `;

  //     if (searchTermOnHandCaseTab) {
  //         query += `AND (Item_Code LIKE '%${searchTermOnHandCaseTab}%' OR Item_Name LIKE '%${searchTermOnHandCaseTab}%') `;
  //     }

  //     query += `ORDER BY Item_Code ASC`;

  //     try {
  //         const itemOnHandCaseTab = await getDataWithComp('API_1101_WH_ITEM_ONHAND', query);

  //         if (itemOnHandCaseTab && itemOnHandCaseTab.length > 0) {
  //             setFormItemOnHandCaseTab(itemOnHandCaseTab);
  //         } else {
  //             setFormItemOnHandCaseTab([]);
  //         }
  //     } catch (error) {
  //         getAlert('FAILED', error.message);
  //     }
  // };

  return (
    <>
      <Breadcrumbs
        page={"คลังสินค้า"}
        items={[
          { name: "คลังสินค้า", url: "/Warehouse" },
          { name: name, url: "/warehouse-stock" },
          { name: "สร้าง" + name, url: "#" },
        ]}
      />

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div style={{ maxHeight: "85vh", overflowY: "auto" }}>
        <div className="container-fluid my-2">
          <div className="row">
            <div className="col-4">
              <div className="d-flex align-items-center">
                <h5 className="text-nowrap card-title mb-0 me-3">
                  ค้นหาสินค้า
                </h5>
                <input
                  type="text"
                  className="form-control"
                  value={searchItemTerm}
                  onChange={(e) => {
                    setSearchItemTerm(e.target.value);
                    localStorage.setItem("stc-item-search", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-8">
              <div className="d-flex">
                <select
                  className="form-select"
                  style={{ maxWidth: "190px" }}
                  value={filterOption}
                  onChange={(e) => {
                    setFilterOption(e.target.value);
                    localStorage.setItem("stc-item-option", e.target.value);
                  }}
                >
                  <option value="0">แสดงยอดคงเหลือ &#62; 0</option>
                  <option value="1">แสดงยอดคงเหลือ &#62; = 0</option>
                  <option value="2">แสดงยอดคงเหลือ = 0</option>
                  <option value="3">แสดงยอดคงเหลือ &#60; 0</option>
                  <option value="4">แสดงทุกรายการ</option>
                </select>
                <i
                  className="fa fa-search fs-4 mx-4"
                  style={{ cursor: "pointer" }}
                  aria-hidden="true"
                  onClick={() => handleItemSearch(searchItemTerm, filterOption)}
                />
                <button
                  className="btn text-white mx-4"
                  style={{ backgroundColor: "rgb(239, 108, 0)" }}
                  onClick={() => ExportInventories(formItemOnHand)}
                >
                  <i className="fa fa-file-excel me-1" aria-hidden="true"></i>{" "}
                  Export สินค้ายอดคงเหลือ
                </button>
                <button
                  className="btn text-white"
                  style={{ backgroundColor: "rgb(239, 108, 0)" }}
                  onClick={() =>
                    ExportInventoriesWarehouse(formItemOnHandCaseTab)
                  }
                >
                  <i className="fa fa-warehouse me-1" aria-hidden="true"></i>{" "}
                  Export สินค้าแยกตามคลัง
                </button>
              </div>
            </div>
            <div className="col-2" />
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-6">
            <div className="col-12">
              <div className="card">
                <h5 className="card-title mt-3 me-4 text-center">
                  สินค้าทั้งหมด
                </h5>
                <div className="card-body">
                  <div
                    className="table-responsive"
                    style={{ maxHeight: "350px", overflowY: "auto" }}
                  >
                    <table
                      id="basic-datatables"
                      className="table table-striped table-hover"
                    >
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-center" style={{ width: "1%" }}>
                            #
                          </th>
                          <th className="text-center" style={{ width: "17%" }}>
                            รหัสสินค้า
                          </th>
                          <th className="text-center" style={{ width: "42%" }}>
                            ชื่อสินค้า
                          </th>
                          <th className="text-center" style={{ width: "13%" }}>
                            <select
                              className="form-select form-select-sm"
                              value={selectedUnit}
                              onChange={(e) => setSelectedUnit(e.target.value)}
                            >
                              <option value="stock">หน่วยสต๊อก</option>
                              <option value="sell">หน่วยขาย</option>
                            </select>
                          </th>

                          <th className="text-center" style={{ width: "10%" }}>
                            คงเหลือ
                          </th>
                          <th className="text-center" style={{ width: "10%" }}>
                            จุดสั่งซื้อ
                          </th>
                          <th className="text-center" style={{ width: "10%" }}>
                            จุดสูงสุด
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formItemList.length > 0 ? (
                          formItemList.map((item, index) => (
                            <tr
                              key={item.Item_Id}
                              onClick={() => {
                                onRowSelectOnHand(item.Item_Id, warehouseId, { preferItemWareSelection: true });
                                localStorage.setItem(
                                  "stc-item-id",
                                  item.Item_Id
                                );
                                localStorage.setItem(
                                  "stc-item-wh",
                                  warehouseId
                                );
                              }}
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  item.Reft_ItemOnhand < 0
                                    ? "#ffe5e5"
                                    : itemId === item.Item_Id
                                    ? "rgb(105, 188, 216)"
                                    : "transparent",
                                transition: "background-color 0.3s ease",
                              }}
                            >
                              <td className="text-center">{index + 1}</td>
                              <td className="text-left">{item.Item_Code}</td>
                              <td className="text-left">{item.Item_Name}</td>
                              <td className="text-center">
                                {selectedUnit === "stock"
                                  ? item.Item_Unit_ST
                                  : item.Item_Unit_OUT}
                              </td>
                              <td className="text-end">
                                {formatCurrency(
                                  selectedUnit === "stock"
                                    ? item.Reft_ItemOnhand /
                                        (item.Item_Qty_ST || 1)
                                    : item.Reft_ItemOnhand || 0 // ป้องกันหาร 0
                                )}
                              </td>
                              <td className="text-end">
                                {formatCurrency(item.Item_PoPoint)}
                              </td>
                              <td className="text-end">
                                {formatCurrency(item.Item_MaxOnhand)}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={7}>
                              <center>
                                <h5>ไม่พบข้อมูล</h5>
                              </center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="col-12">
              <div className="card">
                <h5 className="card-title mt-3 me-4 text-center">
                  สินค้าคงเหลือแยกตามคลัง
                </h5>
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      id="basic-datatables"
                      className="table table-striped table-hover"
                    >
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-center" style={{ width: "15%" }}>
                            รหัสสินค้า
                          </th>
                          <th className="text-center" style={{ width: "30%" }}>
                            ชื่อสินค้า
                          </th>
                          <th className="text-center" style={{ width: "10%" }}>
                            คงเหลือ
                          </th>
                          <th className="text-center" style={{ width: "25%" }}>
                            คลังสินค้า
                          </th>
                          <th className="text-center" style={{ width: "20%" }}>
                            รายการล่าสุด
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formItemOnHand.length > 0 ? (
                          formItemOnHand.map((item, index) => (
                            <tr key={item.Item_Id || index + 1}>
                              <td className="text-center">{item.Item_Code}</td>
                              <td className="text-left">{item.Item_Name}</td>
                              <td className="text-end">
                                {formatCurrency(
                                  selectedUnit === "stock"
                                    ? item.Item_Onhand / (item.Item_Qty_ST || 1)
                                    : item.Item_Onhand || 0 // ป้องกันหาร 0
                                )}
                              </td>
                              <td className="text-center">{item.WH_Name}</td>
                              <td className="text-center">
                                {item.Last_STC_Date
                                  ? formatDateAndTime(item.Last_STC_Date)
                                  : ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6}>
                              <center>
                                <h5>ไม่พบข้อมูล</h5>
                              </center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === 1 ? "active" : ""}`}
                      onClick={() => {
                        setActiveTab(1);
                        localStorage.setItem("stc-active-tab", 1);
                      }}
                    >
                      สินค้าคงเหลือแยกตามคลัง
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === 2 ? "active" : ""}`}
                      onClick={() => {
                        setActiveTab(2);
                        localStorage.setItem("stc-active-tab", 2);
                      }}
                    >
                      ประวัติสินค้าเคลื่อนไหว
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content mt-3">
                <div
                  className={`tab-pane fade ${
                    activeTab === 1 ? "show active" : ""
                  }`}
                  role="tabpanel"
                >
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <div className="col-4 d-flex">
                          <h4 className="card-title mb-0 me-2">เลือกคลัง</h4>
                          <select
                            style={{ width: "200px" }}
                            className="form-select"
                            value={warehouseId}
                            onChange={(e) => {
                              onChangeWarehouse(e.target.value);
                              localStorage.setItem(
                                "stc-select-warehouse",
                                e.target.value
                              );
                            }}
                          >
                            <option value={""}>กรุณาเลือกคลัง</option>
                            {whDataList.map((ware) => (
                              <option key={ware.WH_Id} value={ware.WH_Id}>
                                {ware.WH_Name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-4 d-flex"></div>
                        <div className="col-4 d-flex"></div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table
                            id="basic-datatables"
                            className="table table-striped table-hover"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  รหัสสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "60%" }}
                                >
                                  ชื่อสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "6%" }}
                                >
                                  คงเหลือ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "12%" }}
                                >
                                  คลังสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "12%" }}
                                >
                                  วันที่ทำรายการล่าสุด
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {formItemOnHandCaseTab.length > 0 ? (
                                formItemOnHandCaseTab.map((item, index) => (
                                  <tr key={item.Item_Id || index + 1}>
                                    <td className="text-center">
                                      {item.Item_Code}
                                    </td>
                                    <td className="text-left">
                                      {item.Item_Name}
                                    </td>
                                    <td className="text-end">
                                      {formatCurrency(item.Item_Onhand)}
                                    </td>
                                    <td className="text-center">
                                      {item.WH_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.Last_STC_Date
                                        ? formatDateAndTime(item.Last_STC_Date)
                                        : ""}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={10}>
                                    <center>
                                      <h5>ไม่พบข้อมูล</h5>
                                    </center>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${
                    activeTab === 2 ? "show active" : ""
                  }`}
                  role="tabpanel"
                >
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="container-fluid">
                          <div className="d-flex flex-row">
                            <div className="col-3 d-flex">
                              <h4 className="card-title mb-0 me-2">
                                เลือกคลัง
                              </h4>
                              <select
                                style={{ width: "200px" }}
                                className="form-select"
                                value={warehouseId}
                                onChange={(e) => {
                                  onChangeWarehouse(e.target.value);
                                  localStorage.setItem(
                                    "stc-select-warehouse",
                                    e.target.value
                                  );
                                }}
                              >
                                <option value={""}>กรุณาเลือกคลัง</option>
                                {whDataList.map((ware) => (
                                  <option key={ware.WH_Id} value={ware.WH_Id}>
                                    {ware.WH_Name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-3 d-flex">
                              <label className="fw-bold">ปี : </label>
                              <input
                                type="text"
                                className="form-control mx-1"
                                value={year}
                                onChange={(e) => {
                                  setYear(e.target.value);
                                  localStorage.setItem(
                                    "stc-year",
                                    e.target.value
                                  );
                                }}
                              />
                              <select
                                className="form-select"
                                value={month}
                                onChange={(e) => {
                                  setMonth(e.target.value);
                                  localStorage.setItem(
                                    "stc-month",
                                    e.target.value
                                  );
                                }}
                              >
                                <option value="">กรุณาระบุเดือน</option>
                                <option value="01">มกราคม</option>
                                <option value="02">กุมภาพันธ์ </option>
                                <option value="03">มีนาคม</option>
                                <option value="04">เมษายน</option>
                                <option value="05">พฤษภาคม</option>
                                <option value="06">มิถุนายน</option>
                                <option value="07">กรกฎาคม</option>
                                <option value="08">สิงหาคม</option>
                                <option value="09">กันยายน</option>
                                <option value="10">ตุลาคม</option>
                                <option value="11">พฤศจิกายน</option>
                                <option value="12">ธันวาคม</option>
                              </select>
                              <button
                                className="btn btn-outline-secondary"
                                onClick={() =>
                                  handleHistorySearch(
                                    year,
                                    month,
                                    itemId,
                                    warehouseId
                                  )
                                }
                              >
                                <i className="fas fa-search"></i>
                              </button>
                            </div>
                            <div className="col-4 mx-5">
                              {/* <div className='d-flex'>
                                  <h4 className="card-title mb-0 me-2">ค้นหา</h4>
                                  <div className="input-group w-50">
                                      <input
                                          type="text"
                                          className="form-control"
                                          value={searchHistoryTerm}
                                          onChange={(e) => setSearchHistoryTerm(e.target.value)}
                                      />
                                      <button className="btn btn-outline-secondary" onClick={handleHistorySearch}>
                                          <i className="fas fa-search"></i>
                                      </button>
                                  </div>
                              </div> */}
                            </div>
                            <div className="col-2 mx-2">
                              <div className="d-flex">
                                {formItemHistory[0] ? (
                                  <button
                                    className="btn text-white btn-lg"
                                    onClick={handleWhShow}
                                    style={{
                                      backgroundColor: "rgb(239, 108, 0)",
                                    }}
                                  >
                                    <i
                                      className="fa fa-edit me-1"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    ปรับปรุงคลัง
                                  </button>
                                ) : (
                                  <button
                                    className="btn text-white btn-lg"
                                    onClick={handleItemShow}
                                    style={{
                                      backgroundColor: "rgb(239, 108, 0)",
                                    }}
                                  >
                                    <i
                                      className="fa fa-plus me-1"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    เริ่มต้นประวัติคลัง
                                  </button>
                                )}
                                <ItemModal
                                  formDetailList={[]}
                                  showItemModal={showItemModal}
                                  handleItemClose={handleItemClose}
                                  itemDataList={formItemList.filter(
                                    (item) => item.Reft_ItemOnhand <= 0
                                  )}
                                  onRowSelectItem={handleBeginWarehouse}
                                />
                                <AdjustWhModal
                                  whDataList={whDataList}
                                  showWhModal={showWhModal}
                                  handleWhClose={handleWhClose}
                                  itemDetailModal={formItemHistory[0]}
                                  warehouseId={warehouseId}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table
                            id="basic-datatables"
                            className="table table-striped table-hover"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "1%" }}
                                >
                                  #
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  รหัสสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "23%" }}
                                >
                                  ชื่อสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "5%" }}
                                >
                                  ประเภท
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  จำนวน
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "7%" }}
                                >
                                  จำนวนคงเหลือ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  วันที่ทำรายการ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  คลังสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  เลขเอกสาร
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  เอกสารอ้างอิง
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  หมายเหตุ
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {formItemHistory.length > 0 ? (
                                formItemHistory.map((item, index) => (
                                  <tr key={item.STC_Id}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center">
                                      {item.Item_Code}
                                    </td>
                                    <td className="text-left">
                                      {item.Item_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.Doc_Type}
                                    </td>
                                    <td className="text-end">
                                      {item.Doc_Type === "TO" ||
                                      item.Doc_Type === "AO" ||
                                      item.Doc_Type === "OUT"
                                        ? "-"
                                        : ""}
                                      {formatCurrency(item.STC_QTY)}{" "}
                                      {getUnit(item.Item_Code) !== ""
                                        ? `(${getUnit(item.Item_Code)})`
                                        : ""}
                                    </td>
                                    <td className="text-end">
                                      {formatCurrency(item.STC_Balance)}{" "}
                                      {getUnit(item.Item_Code) !== ""
                                        ? `(${getUnit(item.Item_Code)})`
                                        : ""}
                                    </td>
                                    <td className="text-center">
                                      {formatDateAndTime(item.STC_Date)}
                                    </td>
                                    <td className="text-center">
                                      {item.WH_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.Doc_No}
                                    </td>
                                    <td className="text-center">
                                      {item.Doc_NoRef &&
                                        item.Doc_NoRef.split("ยกเลิก").map(
                                          (part, index, array) => (
                                            <React.Fragment key={index}>
                                              {part}
                                              {index < array.length - 1 && (
                                                <span
                                                  style={{
                                                    color: "red",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  <strong>ยกเลิก</strong>
                                                </span>
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                    </td>
                                    <td className="text-center">
                                      {item.STC_Remark || "-"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={12}>
                                    <center>
                                      <h5>ไม่พบข้อมูล</h5>
                                    </center>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Form;
